import {ChangeDetectionStrategy, Component, HostBinding, Input} from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'td[appTd]',
  templateUrl: './data-table-cell.component.html',
  styleUrls: ['./data-table-cell.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTableCellComponent {
  @HostBinding('class.data-table__cell') class = true;
  @Input() disabled: boolean = false;

  constructor() {
  }

}
